// Campana de alerta sintetizada (sin archivos de audio). Fuerte y repetida
// para que se escuche desde el mostrador.
let ctx = null;

const getCtx = () => {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
};

// Debe llamarse dentro de un gesto del usuario (click/tecla) para que el
// navegador permita reproducir audio después sin interacción.
export const unlockAudio = async () => {
  const c = getCtx();
  if (!c) return false;
  try { if (c.state === "suspended") await c.resume(); } catch { /* ignore */ }
  return c.state === "running";
};

export const audioUnlocked = () => !!ctx && ctx.state === "running";

const bell = (c, t0, freq, dur, gain) => {
  const master = c.createGain();
  master.gain.setValueAtTime(0.0001, t0);
  master.gain.exponentialRampToValueAtTime(gain, t0 + 0.01);
  master.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  master.connect(c.destination);
  // Fundamental + dos armónicos para timbre de campana
  [[1, 1], [2.01, 0.45], [3.0, 0.2]].forEach(([mult, g]) => {
    const o = c.createOscillator();
    const og = c.createGain();
    o.type = "sine";
    o.frequency.setValueAtTime(freq * mult, t0);
    og.gain.setValueAtTime(g, t0);
    o.connect(og); og.connect(master);
    o.start(t0); o.stop(t0 + dur + 0.05);
  });
};

// "Ding-dong" ×3. ~3 s en total.
export const playOrderChime = async ({ repeats = 3, volume = 1.0 } = {}) => {
  const c = getCtx();
  if (!c) return false;
  if (c.state === "suspended") { try { await c.resume(); } catch { return false; } }
  if (c.state !== "running") return false;
  const t = c.currentTime + 0.02;
  for (let i = 0; i < repeats; i++) {
    const base = t + i * 1.0;
    bell(c, base, 1318.5, 0.55, volume);        // E6
    bell(c, base + 0.28, 1760.0, 0.75, volume); // A6
  }
  return true;
};
